import { inject, InjectionToken, Provider } from '@angular/core';

export const MAILGUN_BLOCK_DEPTH = new InjectionToken<number>(`Emulated mailgun scope`);

export const provideMailgunBlockDepth = (): Provider => ({
  provide: MAILGUN_BLOCK_DEPTH,
  useFactory: () => {
    const parent = inject(MAILGUN_BLOCK_DEPTH, { optional: true, skipSelf: true });
    return Number.isInteger(parent) ? parent! + 1 : 0;
  },
});

export const injectMailgunBlockDepth = () => inject(MAILGUN_BLOCK_DEPTH);
